import { createAction } from '@reduxjs/toolkit';

export const requestViewAllNotifications = createAction('request/viewAllNotifications');
export const requestQueryNewNotifications = createAction('request/queryNewNotifications');
export const requestViewNewNotifications = createAction('request/viewNewNotifications');
